/**
 * Iter-251 — Community Channel Tabs.
 *
 * Horizontal pill bar shown at the top of CommunityFeed.
 * "All" + 6 professional channels (brand-ambassadors / bartenders-servers /
 * field-managers / content-creators / influencers / ggf).
 */
import React, { useEffect, useState } from 'react';
import api from '../utils/api';
import { Sparkles } from 'lucide-react';


export default function CommunityChannelTabs({ active, onChange }) {
  const [channels, setChannels] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    api.get('/community/channels')
      .then((res) => { if (!cancelled) setChannels(res.data.channels || []); })
      .catch(() => {})
      .finally(() => { if (!cancelled) setLoading(false); });
    return () => { cancelled = true; };
  }, []);

  if (loading) return null;

  const pill = (key, label, icon, color, count) => {
    const isActive = active === key;
    const style = isActive && color
      ? { backgroundColor: color, color: 'white', borderColor: color }
      : {};
    return (
      <button
        key={key}
        onClick={() => onChange(key)}
        style={style}
        className={`flex-shrink-0 inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full text-xs font-semibold border transition ${
          isActive
            ? 'shadow-md'
            : 'bg-white text-slate-700 border-slate-200 hover:border-slate-300 hover:bg-slate-50'
        }`}
        data-testid={`channel-tab-${key}`}
      >
        <span className="text-sm">{icon}</span>
        <span>{label}</span>
        {count > 0 && (
          <span
            className={`ml-1 text-[10px] px-1.5 rounded-full ${
              isActive ? 'bg-white/20 text-white' : 'bg-slate-100 text-slate-600'
            }`}
          >
            {count}
          </span>
        )}
      </button>
    );
  };

  return (
    <div
      className="flex gap-2 overflow-x-auto pb-1 -mx-1 px-1"
      data-testid="community-channel-tabs"
    >
      {pill('all', 'All', <Sparkles className="w-3.5 h-3.5" />, null, 0)}
      {channels.map((c) =>
        pill(c.slug, c.name, c.icon || '•', c.color, c.post_count_7d),
      )}
    </div>
  );
}
